import { HttpClient } from '@angular/common/http';
import { Component, ElementRef } from '@angular/core';
import { FirebaseAnalytics } from "@capacitor-community/firebase-analytics";
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { Device } from '@capacitor/device';
import { Network } from '@capacitor/network';
import { StatusBar } from '@capacitor/status-bar';
import { AlertController, LoadingController, NavController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/services/auth/auth.service';
import { WENEA_CLOUD_URL } from 'src/app/utils/properties';
import { register } from 'swiper/element/bundle';
import { PreviousUrlService } from './services/previous-url/previous-url.service';

register();
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  public language: string;
  public languageCut: string;
  public platform;
  public url: string = WENEA_CLOUD_URL;
  public backend = false;
  public network = false;
  public cont = 0;
  public netStatus = false;
  public currURL;

  constructor(
    private translate: TranslateService,
    private authService: AuthService,
    private http: HttpClient,
    public alertController: AlertController,
    public loadingCtrl: LoadingController,
    private elementRef: ElementRef,
    private navController: NavController,
    private currentURL: PreviousUrlService,
  ) {
    FirebaseAnalytics.initializeFirebase({
      apiKey: "AIzaSyArnANdn856d45tDAWNaXJcNIdL1vkyOUk",
      authDomain: "wenea-81a4e.firebaseapp.com",
      projectId: "wenea-81a4e",
      storageBucket: "wenea-81a4e.appspot.com",
      messagingSenderId: "445295746910",
      appId: "1:445295746910:web:58076df3f825d1096439cf",
      measurementId: "G-50DT8P6WF5"
    });


    StatusBar.setBackgroundColor({
      color: '#00121c'
  });
    
  //   if (Capacitor.getPlatform() == "ios") {
  //   App.addListener('appStateChange', ({ isActive }) => {
  //     if (isActive == true) {
  //         try{
  //           this.currURL = this.currentURL.getCurrentUrl();
  //           console.log("La url actual es", this.currURL);
  //           //this.statusConnection();
  //           if(this.currURL === '/home'){
  //             this.navController.navigateRoot("waiting");
  //             console.log("esta es la url de reinicio");
  //           }
  //           else{
  //             console.log("No hay que recargar la vista");
              
  //           }
  //         }
  //         catch(err) {
  //           console.log("El error generado ha sido: ", err);
  //           this.navController.navigateRoot("waiting");
  //         }
  //     }
  //     else {
  //       console.log("No necesito cargar el mapa de nuevo");
  //     }
  //   });
  // }
    Network.addListener("networkStatusChange", (status) => {
      if (status.connected == false) {
        this.network = false;
      }
      else {
        this.network = true;
      }
      console.log("Network status changed", status);
    });

    this.logLanguageInfo();
    this.translate.setDefaultLang("en");
    this.getUserPlatformInfo();
  }

  ngAfterViewInit() {
    this.crowBarMap();
  }

  public statusConnection = async () => {
    const status = await Network.getStatus();
    console.log("Network status:", status.connectionType);
    if(status.connectionType == "none" || status.connectionType == "unknown"){
      this.netStatus = false;
    }
    else{
      this.netStatus = true;
    }
  }

  public presentAlertExit() {
    this.alertController
      .create({
        header: this.translate.instant("Ha habido un error"),
        message: this.translate.instant("Su teléfono no responde, por favor, conéctese a una red estable o reinicie la app"),
        buttons: [
          {
            text: "OK",
            handler: () => {
              console.log("Me voy");
              App.exitApp();
            },
          },
        ],
      })
      .then((res) => {
        res.present();
      });
  }

  public crowBarMap() {
    let s = document.createElement("script");
    s.type = "text/javascript";
    s.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyC-JtYBqHiUirkyouh3Joz1eYTPns-2mTw";
    this.elementRef.nativeElement.appendChild(s);
  }

  public getUserPlatformInfo = async () => {
    const platform = (await Device.getInfo()).platform;
    this.platform = platform;
    return this.platform;
  }

  public logLanguageInfo = async () => {
    const language = (await Device.getLanguageCode()).value;
    this.languageCut = language.slice(0, 2);
    console.log("LANGUAGE", language);
    console.log("LANGUAGE CUT", this.languageCut);
    this.translate.setDefaultLang(this.languageCut);
  }
}
